"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStraightLineDistance = void 0;
const geolib_1 = require("geolib");
const getStraightLineDistance = (from, to) => {
    const distanceByMetre = (0, geolib_1.getDistance)({ latitude: from.latitude, longitude: from.longitude }, { latitude: to.latitude, longitude: to.longitude });
    const distanceByKilometre = distanceByMetre / 1000;
    return {
        metre: distanceByMetre,
        mile: distanceByKilometre * 0.621371,
        kilometre: distanceByKilometre,
    };
};
exports.getStraightLineDistance = getStraightLineDistance;
//# sourceMappingURL=distance.js.map